import { Link, useLocation } from 'react-router-dom';
import { useLocale } from '../../application/i18n/LocaleProvider';
import { writeStoredLocale } from '../../application/i18n/localePreference';
import { listLanguageChoices } from '../../domain/i18n/languages';
import { withLocale } from '../../domain/i18n/locales';
import { CheckIcon } from '../icons/ControlIcons';
import FlagDisc from './FlagIcons';

/**
 * Choose the language, without leaving the screen you are on.
 *
 * Three options, not four: the URL carries a market and a language, but the
 * visitor is choosing a language and the market follows from it
 * (`domain/i18n/languages`). Four market-language pairs made a one-word question
 * — "which language?" — into a matrix with English in it twice.
 *
 * Rendered as real links, not a select: each locale is a distinct, shareable,
 * crawlable URL, and a search engine following them is exactly the behaviour the
 * hreflang tags promise.
 *
 * Each option is labelled in ITS OWN language — a visitor who cannot read the
 * current one still has to be able to find theirs.
 */
export default function LanguageSwitcher() {
    const { localeCode, languageCode, t } = useLocale();
    const { pathname } = useLocation();

    return (
        <nav className="language-switcher" aria-label={t('language.switch')}>
            {listLanguageChoices(localeCode).map((choice) => {
                const isCurrent = choice.code === languageCode;

                return (
                    <Link
                        key={choice.code}
                        to={withLocale(pathname, choice.localeCode)}
                        /* The choice is remembered on the CLICK, never while
                           building the href. Writing it per option during render
                           stored whichever option happened to be drawn last, so
                           merely OPENING this menu silently changed the locale the
                           visitor would be negotiated into on their next visit. */
                        onClick={() => writeStoredLocale(choice.localeCode)}
                        className="language-switcher__option"
                        aria-current={isCurrent ? 'true' : undefined}
                        lang={choice.code}
                    >
                        <FlagDisc nation={choice.flagCode} />
                        <span className="language-switcher__name">{choice.endonym}</span>
                        {isCurrent ? <CheckIcon className="language-switcher__check" size={18} /> : null}
                    </Link>
                );
            })}
        </nav>
    );
}
